import { useAuthRestApi } from '../common';
import { useAppConfigContext } from '@vivli/core/infrastructure/context';
import { Observable } from 'rxjs';
import { IChannelUser, IChannelWithBlock, IChatApi } from '@vivli/features/chat/infrastructure/interface';

export const useChatApi = (): IChatApi => {
    const config = useAppConfigContext();
    const { handleGet, handlePost } = useAuthRestApi({
        overrideOptions: { retryCalls: '1', errorHandler: null },
        endpoint: `${config?.chatUri}api`
    });

    const getChatChannel = (channelId: string): Observable<IChannelWithBlock> => {
        return handleGet<IChannelWithBlock>(`/chat/channel/${channelId}`);
    };

    const getChatChannelBlock = (channelId: string, blockId: string): Observable<IChannelWithBlock> => {
        return handleGet<IChannelWithBlock>(`/chat/channel/${channelId}/block/${blockId}`);
    };

    const postChatMessage = (channelId: string, message: string): Observable<void> => {
        return handlePost<void>(`/chat/channel/${channelId}/message`, message);
    };

    const getChannelUser = (userId: string): Observable<IChannelUser> => {
        return handleGet<IChannelUser>(`/chat/channel/user/${userId}`);
    };

    return {
        getChatChannel,
        getChatChannelBlock,
        postChatMessage,
        getChannelUser
    };
};
